/* PLP card photo carousel + in-place color swap.
   Event-delegated so cards fetched later (cat-selector "See more", nav previews,
   filtered grids) work without re-init. Without this file, swatches fall back to
   their real links (today's navigate-to-sibling behavior). */
(function () {
  'use strict';
  if (window.__kwCardPlp) return;
  window.__kwCardPlp = true;

  var SWAP_FADE_MS = 160;

  /* S1: colourway data is one map per product grid (script.kw-sibs-map, keyed by
     product id; snippets/kw-card-sibs-map.liquid) instead of a copy inside every
     card. Maps arrive with the page, infinite-scroll pages, facet re-renders and
     fetched tab panels, so they are absorbed lazily on the first lookup that
     misses. A miss leaves the swatch link to navigate, as it does without JS. */
  var kwSibs = (window.kwSibs = window.kwSibs || { map: Object.create(null), seen: [] });
  function sibById(id) {
    if (!id) return null;
    if (kwSibs.map[id]) return kwSibs.map[id];
    var scripts = document.querySelectorAll('script.kw-sibs-map');
    for (var i = 0; i < scripts.length; i++) {
      if (kwSibs.seen.indexOf(scripts[i]) !== -1) continue;
      kwSibs.seen.push(scripts[i]);
      try {
        var m = JSON.parse(scripts[i].textContent);
        for (var k in m) if (!kwSibs.map[k]) kwSibs.map[k] = m[k];
      } catch (err) {}
    }
    return kwSibs.map[id] || null;
  }

  function getTrack(root) {
    return root.querySelector('.kw-card-track');
  }
  function slideIndex(track) {
    return track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0;
  }
  function updateBar(root, track) {
    var fill = root.querySelector('.kw-card-bar__fill');
    if (!fill || !track.children.length) return;
    fill.style.width = 100 / track.children.length + '%';
    fill.style.transform = 'translateX(' + slideIndex(track) * 100 + '%)';
  }
  function scrollBehavior() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  }
  function escapeAttr(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;');
  }

  /* Pre-order products must be bought from the PDP: the quick-add modal never carries
     the ReStock selling plan (the app only binds on product pages), so a modal add
     posts an untagged oversell line (seen on live 8/21/26). Cards flag pre-order
     products with the PRE-ORDER pill, and the pill follows colourway swaps, so the
     pill is the signal. Capture phase so this runs before modal-opener's own click. */
  document.addEventListener(
    'click',
    function (event) {
      var qa = event.target.closest('.quick-add__submit');
      if (!qa) return;
      var wrapper = qa.closest('.card-wrapper') || qa.closest('.card');
      if (!wrapper || !wrapper.querySelector('.preorder-badge')) return;
      var link = wrapper.querySelector('.card__heading a');
      var url = qa.getAttribute('data-product-url') || (link && link.getAttribute('href'));
      if (!url) return;
      event.preventDefault();
      event.stopPropagation();
      window.location.href = url;
    },
    true
  );

  document.addEventListener('click', function (event) {
    var arrow = event.target.closest('.kw-card-arr');
    if (arrow) {
      event.preventDefault();
      event.stopPropagation();
      var card = arrow.closest('.card');
      var track = card && getTrack(card);
      if (!track || track.children.length < 2) return;
      var dir = arrow.classList.contains('kw-card-arr--next') ? 1 : -1;
      var next = (slideIndex(track) + dir + track.children.length) % track.children.length;
      track.scrollTo({ left: next * track.clientWidth, behavior: scrollBehavior() });
      return;
    }

    var swatch = event.target.closest('.kw-swatch');
    if (!swatch) return;
    if (swatch.classList.contains('kw-swatch--sel')) {
      event.preventDefault();
      return;
    }
    var wrapper = swatch.closest('.card-wrapper');
    if (!wrapper) return;
    var sib = sibById(swatch.getAttribute('data-kw-id'));
    if (!sib || !sib.url) return;
    event.preventDefault();
    swapCard(wrapper, sib, swatch);
  });

  /* scroll events don't bubble — capture them for swipe-driven bar updates */
  document.addEventListener(
    'scroll',
    function (event) {
      var track = event.target;
      if (!track || !track.classList || !track.classList.contains('kw-card-track')) return;
      var card = track.closest('.card');
      if (!card || track.__kwRaf) return;
      track.__kwRaf = requestAnimationFrame(function () {
        track.__kwRaf = null;
        updateBar(card, track);
      });
    },
    true
  );

  function swapCard(wrapper, sib, swatch) {
    var media = wrapper.querySelector('.kw-card-media');
    var track = getTrack(wrapper);
    if (media) media.classList.add('kw-swapping');

    setTimeout(function () {
      if (track && sib.images && sib.images.length) {
        var sizes = track.getAttribute('data-kw-sizes') || '';
        track.innerHTML = sib.images
          .map(function (im) {
            return (
              '<div class="kw-card-slide"><img src="' + escapeAttr(im.src) +
              '" srcset="' + escapeAttr(im.srcset) +
              '" sizes="' + escapeAttr(sizes) +
              '" alt="' + escapeAttr(im.alt) +
              '" loading="lazy" width="' + escapeAttr(im.w) +
              '" height="' + escapeAttr(im.h) + '"></div>'
            );
          })
          .join('');
        track.scrollTo({ left: 0, behavior: 'auto' });
      }
      wrapper.classList.toggle('kw-single', !sib.images || sib.images.length < 2);

      wrapper.querySelectorAll('a.img_link, .card__heading a').forEach(function (a) {
        a.setAttribute('href', sib.url);
      });
      wrapper.querySelectorAll('.card__heading a').forEach(function (a) {
        a.textContent = sib.title;
      });

      var price = wrapper.querySelector('.card-information .price');
      if (price && sib.priceHtml) {
        var holder = document.createElement('div');
        holder.innerHTML = sib.priceHtml;
        var fresh = holder.querySelector('.price');
        if (fresh) price.replaceWith(fresh);
      }

      /* quick-add modal fetches from data-product-url — point it at the shown colorway */
      wrapper.querySelectorAll('[data-product-url]').forEach(function (el) {
        el.setAttribute('data-product-url', sib.url);
      });

      /* Stock markers are decided server-side per product, so a swapped-in
         colorway needs its own. product-badge.liquid emits the sold-out /
         stock-stack markup for every sibling in .kw-card-badge-state, in
         swatch order. Without this the marker is left over from the colorway
         the page loaded with - swapping to a sold-out sibling kept showing LOW
         STOCK and still offered the cart chip.

         LOW STOCK and PRE-ORDER AVAILABLE now arrive together inside one
         .kw-badge-stack wrapper, so the wrapper is what gets replaced; the
         bare .low-badge selector stays for any card rendered before that
         change. The discount pill (.bundle-badge--card) is deliberately left
         in place so it is never wiped by a swap. */
      var badgeHost = wrapper.querySelector('.kw-card-media') ||
        wrapper.querySelector('.card__media .media');
      if (badgeHost) {
        var stateEl = wrapper.querySelector('.kw-card-badge-state');
        var markup = null;
        if (stateEl) {
          try {
            markup = JSON.parse(stateEl.textContent)[Number(swatch.getAttribute('data-kw-idx'))];
          } catch (err) {
            markup = null;
          }
        }
        if (typeof markup === 'string') {
          badgeHost.querySelectorAll('.kw-badge-stack, .low-badge, .bundle-badge--soldout').forEach(function (el) {
            el.remove();
          });
          if (markup) badgeHost.insertAdjacentHTML('afterbegin', markup);
        }
      }

      wrapper.querySelectorAll('.kw-swatch--sel').forEach(function (el) {
        el.classList.remove('kw-swatch--sel');
      });
      swatch.classList.add('kw-swatch--sel');

      var card = wrapper.querySelector('.card');
      if (track && card) updateBar(card, track);
      if (media) media.classList.remove('kw-swapping');
    }, SWAP_FADE_MS);
  }
})();
